<template>
  <div class="tel-con">
    <a-input class="input" @blur="phoneChange" :placeholder="$t('login.phoneNumber')" v-model.number="userPhone">
      <a-icon slot="prefix" type='phone' style="color:rgba(0,0,0,.25)" />
    </a-input>
    <a-input  class="input" @blur="inputComplete" autocomplete="off" :placeholder="$t('login.verifyCode')" v-model="verifyCode">
      <!-- <a-icon slot="prefix" type='user' style="color:rgba(0,0,0,.25)" /> -->
      <zx-icon slot="prefix" type='icon-yanzhengma' style="color:#ccc"></zx-icon>
    </a-input>
    <div class="verifycode">
      <img class="img" :src="verifyCodeUrl" @click="refreshVerifyCode" :alt="$t('login.verifyCode')">
      <a-button  class="sendbtn" v-if="showSendBtn" :disabled="messageDisabled" @click="sendPhoneMessage">{{$t('login.sendSms')}}</a-button>
      <div class="text" v-else>{{time + $t('login.sendAgain')}}</div>
    </div>
    <a-input  class="input" :placeholder="$t('login.smsVerifyCode')" v-model="messageVerifyCode">
      <a-icon slot="prefix" type='key' style="color:rgba(0,0,0,.25)" />
    </a-input>
    <a-button class="submit" type="primary" :disabled="submitDisabled" @click="phoneSubmit">{{$t('login.login')}}</a-button>
  </div>
</template>
<script>
import config from '../config'
import Vue from 'vue'
import {loginSuccess} from '../model/loginSuccess'
export default {
  data () {
    return {
      userPhone: '',
      messageVerifyCode: '',
      verifyCode: '',
      verifyCodeUrl: '',
      phoneStatus: false,
      showSendBtn: true,
      time: 60
    }
  },
  computed: {
    messageDisabled () {
      return !(this.phoneStatus && this.verifyCode)
    },
    submitDisabled () {
      return !(!this.messageDisabled && this.messageVerifyCode)
    }
  },
  methods: {
    phoneChange () {
      // console.log(e)
      if (!this.isPhoneNumber(this.userPhone)) {
        // ...
        this.phoneStatus = false
        this.$emit('errInfo', this.$t('login.phoneNumberFormatError'))
      } else {
        this.phoneStatus = true
        this.$emit('ok')
      }
    },
    inputComplete () {
      if (this.verifyCode) {
        if ( this.verifyCode.length === 4) {
          this.$emit('ok')
        } else {
          this.$emit('errInfo', this.$t('login.verifyCodeLengthError'))
          // this.refreshVerifyCode()
        }
      } else {
        this.$emit('errInfo', this.$t('login.verifyCodeIsNull'))
        // this.refreshVerifyCode()
      }
    },
    /**判断是否是手机号**/
    isPhoneNumber (tel) {
      let reg =/^1(3|4|5|7|8)\d{9}$/
      return reg.test(tel)
    },
    phoneSubmit () {
      // console.log('submit')
      let loginData = {
        phoneNum: this.userPhone,
        smsVerifyCode: this.messageVerifyCode,
        version: 'ccccc',
        platform: 'dddddddd'
      }
      this.$http.post(config.api.login_by_phone, loginData).then((res) => {
        // console.log(res)
        if (res.code !== 0) {
          // debugger
          this.$emit('errInfo', res.desc)
          // 不清空图片验证码
          // this.verifyCode = ''
          this.messageVerifyCode = ''
          this.time = 60
          // 不刷新验证码
          // this.getVerifyCode()
          // this.$notification.warning({
          //   message: '登陆失败',
          //   description: '密码错误或者账号不存在'
          // })
        } else {
          let result = res.result
          // console.log(result)
          // let userid = result.userid
          // let userImage = result.userLogo
          // let token = result.token
          // let orgName = result.orgName
          // let systemImage = result.systemLogo
          // let systemName = result.systemName
          // // let expiration = result.expiration ? result.expiration : 3600 * 1000
          // let roles = result.roles
          // let level = result.level
          
          // this.$store.dispatch('setToken', {
          //   token: token,
          //   // expiration: expiration
          // })
          // this.$store.dispatch('setLevel', level)

          // this.$store.dispatch('setUser', {
          //   name: result.username,
          //   id: userid,
          //   roles: roles,
          //   userImage: userImage
          // })
          // this.$store.dispatch('setOrg', {
          //   level: level,
          //   systemImage: systemImage,
          //   systemName: systemName,
          //   orgName
          // })
          // if (roles && roles === 'SuperAdmin') {
          //   Vue.ls.set('activeMenu', 1);
          //   this.$router.push('/overview')
          // }  else{
          //   Vue.ls.set('activeMenu', 1);
          //   this.$router.push('/home')
          // }
          loginSuccess(result)
          this.$notification.success({
              message: this.$t('login.loginSuccess'),
              description: result.username + ', ' + this.$t('login.welcome')
          })
        }
      })
    },
    sendPhoneMessage () {
      // console.log('send')
      this.$http.get(config.api.apply_send_phone_message + this.userPhone + '/' + this.verifyCode).then((res) => {
        if (res.code === 0) {
          // this.$emit('ok')
          // 1 hide 发送短信按钮
          this.showSendBtn = false
          // 设置一个定时器一分钟后显示按钮
          this.setTime = setInterval(() => {
            if (this.time) {
              this.time--
            } else {
              this.time = 60
              this.showSendBtn = true
              this.setTime && clearInterval(this.setTime)
              this.verifyCode = ''
              this.refreshVerifyCode()
            }
          }, 1000)
          // 然后就没有然后了
        } else {
          this.$emit('errInfo', res.desc)
          // 刷新图片验证码
          this.refreshVerifyCode()
        }
      })
    },
    getVerifyCode () {
      let random = Math.floor(Math.random() * 100)
      this.verifyCodeUrl = `${config.api.verify_image_url}/api/commons/v1.0/verifyCode/image?key=${random}&isPwd=false`
      // console.log(this.verifyCodeUrl)
    },
    refreshVerifyCode () {
      this.getVerifyCode()
    },
  },
  // 组件销毁前需要检查是否存在计时器，存在就销毁，不然很浪费性能！
  beforeDestroy () {
    this.setTime && clearInterval(this.setTime)
  },
  mounted () {
    this.getVerifyCode()
  }
}
</script>
<style lang="less" scoped>
.tel-con {
  // ...
  width: 300px;
  .input {
    margin: 20px 0 0 0;
  }
  .verifycode {
    display: flex;
    margin: 10px 0 0 0;
    align-items: center;
    .img {
      width: 20%;
      margin-right: 20px;
    }
  }
  .submit {
    margin: 20px 0 0 0;
    width: 100%;
  }
}
</style>
